import React, { useState } from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../../../Shared/SectionTitle/SectionTitle";
import { OtherAttachments } from "../../../../../api/OtherAttachments";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  // boxShadow: 24,
  p: 4,
};

const TeamSection = (props) => {
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const handleOpen = (image, title, description) => {
    setImage(image);
    setTitle(title);
    setDescription(description);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="wpo-team-section section-padding">
      <div className="container">
        <SectionTitle
          subTitle={"Nous offrons"}
          MainTitle={"Accessoires Tracteur"}
        />
        <div className="wpo-team-wrap">
          <div
            className="row"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {OtherAttachments.map((accessoire) => (
              <div
                style={{ cursor: "pointer" }}
                className="col-lg-3 col-md-4 col-sm-6 col-12"
                key={accessoire.id}
                onClick={() =>
                  handleOpen(
                    accessoire.image,
                    accessoire.title,
                    accessoire.description
                  )
                }
              >
                <div className="wpo-team-item">
                  <div className="wpo-team-img">
                    <img src={accessoire.image} alt="" />
                  </div>
                  <div className="wpo-team-text">
                    <h3>{accessoire.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {title}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {description}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <img src={image} alt="" />
          </Typography>
        </Box>
      </Modal>
    </section>
  );
};

export default TeamSection;
